module.exports = __webpack_public_path__ + "809e3043c83a1df7bbce65487eaab486.svg";